import { useQuery } from '@tanstack/react-query';
import { fetchPosts } from '../utils/utils';

export function usePosts() {
  return useQuery({
    queryKey: ['posts'],
    queryFn: () => fetchPosts(),
  });
}